import reducer from "./reducer";
export { default as DocumentPublication } from "./components/index";
export { default as documentPublicationReducerName } from "./constants";
export default reducer;
